export default __webpack_public_path__ + "static/media/WhiteLogo.d20bd324.svg";